module.exports = __webpack_public_path__ + "static/mermaid-2-06d34749f888ec1b3beb6120bbe4c552.jpg";